module.exports = __webpack_public_path__ + "static/media/shredder.f6c250bf.png";